import { useInfiniteQuery } from "react-query";
import { toast } from "react-toastify";
import { ILead } from "lib/types/leads.types";
import { usePagination } from "lib/hooks/shared/usePagination";
import { getCustomers } from "api/Customers";

export const useCoustomers = (
  filter_search: string,
  filter_status: string,
  filter_product: string,
  filter_company: string,
  filter_commission: string,
  filter_mandated: string,
  customer_type: string,
  filter_created_at: string,
  filter_to_created_at: string,
  filter_from_user: string,
) => {
  const {
    currentPage,
    handleItemsPerPageChange,
    handleNextPage, 
    handlePreviousPage,
    itemsPerPage
  } = usePagination(1, 100);

  const { data, isLoading, hasNextPage, hasPreviousPage } = useInfiniteQuery<Array<ILead> | any>(
    ["coustomers", currentPage, itemsPerPage, filter_search, filter_status, filter_product, filter_company, filter_commission, filter_mandated,customer_type, filter_created_at,filter_to_created_at, filter_from_user],
    ({ pageParam = currentPage }) => {
      return getCustomers({
        page: pageParam,
        number_per_page: itemsPerPage,
        filter_search: filter_search,
        filter_status: filter_status,
        filter_product: filter_product,
        filter_company: filter_company,
        filter_commission: filter_commission,
        filter_mandated: filter_mandated,
        customer_type: customer_type,
        filter_created_at: filter_created_at,
        filter_to_created_at: filter_to_created_at,
        from_user: filter_from_user
      } as any);
    },
    {
      getNextPageParam: (lastPage) => {
        return lastPage?.data?.next_page_url
          ? new URL(lastPage.data.next_page_url).searchParams.get("page")
          : false;
      },
      getPreviousPageParam: (firstPage, allPages) => {
        const currentPage = allPages[allPages.length - 1];
        const prevPageUrl = currentPage?.data?.prev_page_url;
        return prevPageUrl
          ? new URL(prevPageUrl).searchParams.get("page")
          : false;
      },
      onError: () => {
        toast.error(`Something went wrong`);
      }
    }
  );

  return {
    data,
    isLoading,
    hasNextPage,
    hasPreviousPage,
    currentPage,
    itemsPerPage,
    handleNextPage,
    handlePreviousPage,
    handleItemsPerPageChange
  };
};
